import * as React from "react";

import { Doc } from "affinityUI/structures/doc";

import editPatientLink from "./assets/Edit patient link.png";

export const PatientInformationSection: React.FC = () => {
  return (
    <Doc.Section title="Patient Information">
      <p>
        To change patient information, click the “Edit” link on the Review Patient page. To be able to change patient
        information your user profile should have corresponding permissions. The link will not be visible if access to
        this functionality is not allowed for your user profile. If such situation occurs and you need access to this
        functionality, please contact the Entia support team.
      </p>
      <Doc.Illustration src={editPatientLink} label="Edit patient link" />
      <p>
        To change information about the patient at a later stage, click on the “Edit” link to open the Edit Patient
        page.
      </p>
    </Doc.Section>
  );
};
